export default "__VITE_ASSET__DsD0VEW8__"